// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--FNPSp{0%{background-position:200% 0}100%{background-position:-200% 0}}.header--bM7om{display:flex;align-items:center;justify-content:space-between;height:64px;padding:0 24px;background-color:#fff}.header--bM7om.border-bottom--vzILL{border-bottom:1px solid #d7dae4}.header--bM7om .header-left--oiU36,.header--bM7om .header-right--J5fEX{display:flex;align-items:center;flex-direction:row;flex-shrink:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "header--bM7om",
	"border-bottom": "border-bottom--vzILL",
	"header-left": "header-left--oiU36",
	"header-right": "header-right--J5fEX",
	"shimmer-loading": "shimmer-loading--FNPSp"
};
export default ___CSS_LOADER_EXPORT___;
